import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import utils from '../core/utils';
var Monitor = function () {
    function Monitor(player) {
        var _this = this;
        _classCallCheck(this, Monitor);
        this.player = player;
        this.dazeTimer = null;
        this.dazeTimeCalc = 0;
        this.isClose = false;
        this.userInfo = this.player.userInfo;
        this.initPlayWarning();
        this.initPauseWarning();
        this.initEndWarning();
        if (!this.player.options.disableBar) {
            this.initSeekWarning();
        }
        this.startTime = 0;
        this.endTime = 0;
        this.timeCount = 0;
        this.actualVideoDuration = 0;
        this.playingTimer = null;
        document.onmousemove = function () {
            if (_this.dazeTimer) {
                clearInterval(_this.dazeTimer);
            }
            _this.dazeTimeCalc = 0;
        };
        document.onkeydown = function () {
            if (_this.dazeTimer) {
                clearInterval(_this.dazeTimer);
            }
            _this.dazeTimeCalc = 0;
        };
        this.player.on('timeupdate', function (e) {
            _this.player.socket.noActionTimeCalc = 0;
        });
        if (window.addEventListener) {
            window.addEventListener('beforeunload', this.startReport.bind(this), false);
        } else {
            window.attachEvent('onbeforeunload', this.startReport.bind(this));
        }
    }
    return _createClass(Monitor, [
        {
            key: 'initPlayEvent',
            value: function initPlayEvent() {
                this.listenerEvents = [
                    'pause',
                    'play',
                    'seeked',
                    'seeking',
                    'ended'
                ];
                this.warningEvents = [
                    'VIDEO_PLAY',
                    'VIDEO_PAUSE',
                    'VIDEO_END',
                    'VIDEO_CLOSE',
                    'VIDEO_DRAG',
                    'VIDEO_BACK',
                    'VIDEO_END_DAZE',
                    'VIDEO_PAUSE_DAZE',
                    'VIDEO_PLAYED_SKIP',
                    'VIDEO_UNPLAYED_SKIP'
                ];
            }
        },
        {
            key: 'sendFragmentReport',
            value: function sendFragmentReport() {
                var duration = this.player.video.duration;
                var videoInfo = {
                    event: 'VIDEO_FRAGMENT_REPORT',
                    video_duration: duration || 0,
                    event_begin: this.startTime,
                    event_end: this.endTime,
                    duration: this.timeCount
                };
                this.sendWarningMessage(videoInfo);
            }
        },
        {
            key: 'startReport',
            value: function startReport() {
                if (this.playingTimer) {
                    clearInterval(this.playingTimer);
                    this.playingTimer = null;
                    this.timeCount -= 0.75;
                    if (this.timeCount >= 1) {
                        this.endTime = this.player.video.currentTime;
                        this.sendFragmentReport();
                    }
                    this.timeCount = 0;
                }
            }
        },
        {
            key: 'initPlayWarning',
            value: function initPlayWarning() {
                var _this2 = this;
                this.player.on('play', utils.debounce(function () {
                    if (_this2.dazeTimer) {
                        clearInterval(_this2.dazeTimer);
                        _this2.dazeTimeCalc = 0;
                    }
                    _this2.playingTimer && clearInterval(_this2.playingTimer);
                    _this2.timeCount = 0;
                    var duration = 0;
                    var playedPromise = Promise.resolve(_this2.player.video.play());
                    playedPromise['catch'](function () {
                    }).then(function () {
                        duration = _this2.player.video.duration;
                        var current = _this2.player.video.currentTime;
                        var videoInfo = {
                            event: 'VIDEO_PLAY',
                            video_duration: duration || 0,
                            event_begin: current || 0
                        };
                        _this2.startTime = _this2.player.video.currentTime;
                        _this2.playingTimer = setInterval(function () {
                            _this2.timeCount += 0.25;
                            _this2.actualVideoDuration += 0.25;
                            _this2.player.events.trigger('actual_video_duration', {
                                duration: duration,
                                currentTime: _this2.player.video.currentTime,
                                actual_duration: _this2.actualVideoDuration,
                                left_time: parseInt(duration - _this2.player.video.currentTime)
                            });
                        }, 250);
                        _this2.sendWarningMessage(videoInfo);
                    });
                }, 500, false));
            }
        },
        {
            key: 'initPauseWarning',
            value: function initPauseWarning() {
                var _this3 = this;
                this.player.on('pause', utils.debounce(function () {
                    var duration = _this3.player.video.duration;
                    var current = _this3.player.video.currentTime;
                    var videoInfo = {
                        event: 'VIDEO_PAUSE',
                        video_duration: duration || 0,
                        event_begin: current || 0
                    };
                    if (_this3.player.video.paused) {
                        console.log('paused', !_this3.player.isClose, {
                            current: current,
                            duration: duration
                        }, duration != current);
                        if (duration != current && !_this3.player.isClose) {
                            _this3.startReport();
                            _this3.sendWarningMessage(videoInfo);
                            if (_this3.dazeTimer) {
                                clearInterval(_this3.dazeTimer);
                                _this3.dazeTimeCalc = 0;
                            }
                            _this3.dazeTimer = setInterval(function () {
                                if (_this3.dazeTimeCalc >= 180) {
                                    var dazeMsg = Object.assign({}, videoInfo, { event: 'VIDEO_PAUSE_DAZE' });
                                    _this3.sendWarningMessage(dazeMsg);
                                    _this3.dazeTimeCalc = 0;
                                } else {
                                    ++_this3.dazeTimeCalc;
                                }
                            }, 1000);
                        }
                        _this3.player.isClose = false;
                    }
                }, 500, false));
            }
        },
        {
            key: 'initEndWarning',
            value: function initEndWarning() {
                var _this4 = this;
                this.player.on('ended', utils.debounce(function () {
                    var duration = _this4.player.video.duration;
                    var current = _this4.player.video.currentTime;
                    _this4.startReport();
                    var videoInfo = {
                        event: 'VIDEO_END',
                        video_duration: duration || 0,
                        event_begin: current || 0
                    };
                    _this4.sendWarningMessage(videoInfo);
                    if (_this4.dazeTimer) {
                        clearInterval(_this4.dazeTimer);
                        _this4.dazeTimeCalc = 0;
                    }
                    _this4.actualVideoDuration = 0;
                    _this4.dazeTimer = setInterval(function () {
                        if (_this4.dazeTimeCalc >= 180) {
                            var dazeMsg = Object.assign({}, videoInfo, { event: 'VIDEO_END_DAZE' });
                            _this4.sendWarningMessage(dazeMsg);
                            _this4.dazeTimeCalc = 0;
                        } else {
                            ++_this4.dazeTimeCalc;
                        }
                    }, 1000);
                }, 500, false));
            }
        },
        {
            key: 'initSeekWarning',
            value: function initSeekWarning() {
                var _this5 = this;
                var startTime = 0, endTime = 0, videoInfo = null;
                var dragStartTime = 0, dragEndTime = 0;
                var _thumbUp = function thumbUp() {
                    var event = '';
                    var duration = _this5.player.video.duration;
                    document.removeEventListener(utils.nameMap.dragEnd, _thumbUp);
                    endTime = _this5.player.video.currentTime;
                    if (startTime < endTime) {
                        event = 'VIDEO_DRAG';
                    } else {
                        event = 'VIDEO_BACK';
                    }
                    var eventMap = {
                        VIDEO_DRAG: 'forward',
                        VIDEO_BACK: 'backward'
                    };
                    _this5.player.events.trigger(eventMap[event], {
                        startTime: startTime,
                        endTime: endTime
                    });
                    videoInfo = Object.assign({}, {
                        event: event,
                        video_duration: duration || 0,
                        event_begin: startTime || 0,
                        event_end: endTime || 0
                    });
                    if (!_this5.player.video.paused) {
                        dragEndTime = new Date().getTime();
                        _this5.playingTimer && clearInterval(_this5.playingTimer);
                        _this5.playingTimer = null;
                        if (_this5.timeCount >= 1) {
                            _this5.endTime = parseFloat((startTime + (dragEndTime - dragStartTime) / 1000).toFixed(6));
                            _this5.sendFragmentReport();
                        }
                        _this5.timeCount = 0;
                        var playedPromise = Promise.resolve(_this5.player.video.play());
                        playedPromise.then(function () {
                            _this5.startTime = endTime;
                            _this5.playingTimer = setInterval(function () {
                                _this5.timeCount += 0.25;
                                _this5.actualVideoDuration += 0.25;
                                _this5.player.events.trigger('actual_video_duration', {
                                    duration: _this5.player.video.duration,
                                    currentTime: _this5.player.video.currentTime,
                                    actual_duration: _this5.actualVideoDuration,
                                    left_time: parseInt(duration - _this5.player.video.currentTime)
                                });
                            }, 250);
                        })['catch'](function () {
                        });
                    }
                    _this5.sendWarningMessage(videoInfo);
                };
                this.player.template.playedBarWrap.addEventListener(utils.nameMap.dragStart, function () {
                    startTime = _this5.player.video.currentTime;
                    dragStartTime = new Date().getTime();
                    document.addEventListener(utils.nameMap.dragEnd, _thumbUp);
                });
            }
        },
        {
            key: 'initCloseWarning',
            value: function initCloseWarning() {
                var duration = this.player.video.duration;
                var current = this.player.video.currentTime;
                if (!this.player.video.paused) {
                    this.player.isClose = true;
                    this.player.pause();
                    this.startReport();
                }
                var videoInfo = {
                    event: 'VIDEO_CLOSE',
                    video_duration: duration || 0,
                    event_begin: current || 0
                };
                this.sendWarningMessage(videoInfo);
                if (this.dazeTimer) {
                    clearInterval(this.dazeTimer);
                    this.dazeTimeCalc = 0;
                }
            }
        },
        {
            key: 'initSkipWarning',
            value: function initSkipWarning() {
                var duration = this.player.video.duration;
                var current = this.player.video.currentTime;
                var percent = current;
                var event = '';
                this.startReport();
                if (percent < duration / 3 && current > 0) {
                    event = 'VIDEO_PLAYED_SKIP';
                    var videoInfo = Object.assign({}, {
                        event: event,
                        video_duration: duration || 0,
                        event_begin: current || 0
                    });
                    this.sendWarningMessage(videoInfo);
                } else if (current == 0) {
                    event = 'VIDEO_UNPLAYED_SKIP';
                    var _videoInfo = Object.assign({}, {
                        event: event,
                        video_duration: duration || 0,
                        event_begin: current || 0
                    });
                    this.sendWarningMessage(_videoInfo);
                }
                if (this.dazeTimer) {
                    clearInterval(this.dazeTimer);
                    this.dazeTimeCalc = 0;
                }
            }
        },
        {
            key: 'sendWarningMessage',
            value: function sendWarningMessage(videoInfo) {
                var msg = Object.assign({ user_agent: navigator.userAgent }, this.userInfo, videoInfo);
                this.player.socket.sendEventMessage(msg);
            }
        }
    ]);
}();
export default Monitor;